import { useContext } from 'react';
import { MenuDispatcherContext } from 'providers';

function useMenuDispatcher() {
  return useContext(MenuDispatcherContext);
}

export { useMenuDispatcher };
